import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    'updateSubscriptionForm',
    'updateSubscriptionSubmit',
    'stripeClientSecret', // Holds the value we get when we init a new setup intent
    'cardHolderName', // Is sent to Stripe with the card
    "cardElement", // The "mount point" for Stripe's card element iframe
    'cardErrors',  // Placeholder for Stripe error messages
    'stripePaymentMethodId', // Form submits > Card is saved to Stripe > We get a PaymentMethodId back and store it here
    'chosenProduct', // Now that we allow ordering multiple kinds of products, we use this to store which product is chosen
    'updateSubscriptionMonths1', // Button for toggling prices and payment terms to monthly.
    'updateSubscriptionMonths6', // Button for toggling prices and payment terms to biannualy.
    'summaryQuickToggleBillingMethodMonthly', // Radio button for toggling the prices to monthly.
    'summaryQuickToggleBillingMethodBiannualy', // Radio button for toggling the prices to biannualy.
    'billingMethodInvoiceChoice', // Radio button for toggling the billing method to invoice.
    'billingMethodCardChoice', // Radio button for toggling the billing method to card.
    'subscriptionMonths', // Tracks the chosen subscription months value, like 1 or 6
    ]

  // connect is only triggered on first page load for this form, if the form is submitted and replaced via a 422 error, it's not run again
  connect () {
    this.mountStripeElement();
    this.showAddressAndPaymentFieldsIfProductIsChosen();
    this.preSetLastBillingMethod();
  }

  preSetLastBillingMethod() {
    // check if these targets exists as there are states in which they do not exist!
    if (!(this.hasBillingMethodInvoiceChoiceTarget && this.hasBillingMethodCardChoiceTarget)) {
      return;
    }

    // Set the current billing mehtod.
    if (this.subscriptionMonthsTarget.value != 1) {
      // We set the billing method to match the current selected billing method
        // Card is the default billing method if no method are set.
        if ($('account-form').dataset.currentMethod == 'billing_method_invoice') {
          this.billingMethodInvoiceChoiceTarget.click()
        } else {
          this.billingMethodCardChoiceTarget.click()
        }

        // we click this hidden button to move focus to the top of the page again as this is meant to occur on page load only.
        // Because clicking the radio button causes the focus to move to the bottom of the page. #5849
        document.getElementById('a-button-just-to-move-focus').focus()
      }
  }

  clickBillingMonthsToggleLinks(e) {
    // We do not want to click if the radio button is already checked as it has side effects as moving focus and
    // toggling payment method.
    if (e.target == this.summaryQuickToggleBillingMethodMonthlyTarget && e.target.checked) {
      this.updateSubscriptionMonths1Target.click()
    } else if (e.target == this.summaryQuickToggleBillingMethodBiannualyTarget && e.target.checked && !this.billingMethodInvoiceChoiceTarget.checked) {
      this.updateSubscriptionMonths6Target.click()
    }
  }

  showAddressAndPaymentFieldsIfProductIsChosen() {
    if(this.hasChosenProductTarget && this.chosenProductTarget.value) {
      this.showAddressAndPaymentFields();
    }
  }

  // This happens any time the form is submitted
  onAjaxLoad() {
    this.mountStripeElement();
    this.showAddressAndPaymentFieldsIfProductIsChosen();
  }

  chooseProduct(event) {
    this.chosenProductTarget.value = event.target.dataset.chosenProductCode;
    this.showAddressAndPaymentFields();
  }

  showAddressAndPaymentFields() {
    var fieldsets = $$('.upgrade-form');
    if (!fieldsets) { return; }
    this.updateSubscriptionSubmitTarget.disabled = false;
    fieldsets.set('data-active', 1);
  }

  mountStripeElement () {
    this.stripeCardInstance = window.stripe.elements().create('card', {
      style: {
        base: {
          fontSize: '16px',
          lineHeight: '1.5rem',
        }
      }
    })
    this.stripeCardInstance.mount(this.cardElementTarget)
  }

  handleSubmit (event) {
    // The card form is disabled by our own js-toggler
    // So a disabled stripeClientSecretTarget means that the form is
    // hidden and should not be submitted to Stripe
    if (!this.stripeClientSecretTarget.disabled) {
      event.preventDefault()
      event.stopPropagation()
      this.finishSetupIntent()
    }
  }

  finishSetupIntent () {
    // See https://github.com/imagine-it/Fakturan.nu/wiki/Kortbetalningar---Stripe for an overview
    // of how all card related stuff fits togehter
    let self = this // So you can access stimulus in the stripe callback

    this.updateSubscriptionFormTarget.classList.add('loading')
    this.updateSubscriptionSubmitTarget.disabled = true

    // "stripe.handleCardSetup" finishes / confirms a Setup Intent
    window.stripe.handleCardSetup(
      this.stripeClientSecretTarget.value,
      this.stripeCardInstance,
      { payment_method_data: {
          billing_details: {
          name: this.cardHolderNameTarget.value
          }
        }
      }
    ).then(
      function (result) {
        self.updateSubscriptionFormTarget.classList.remove('loading')
        self.updateSubscriptionSubmitTarget.disabled = false
        if (result.error) {
          self.cardErrorsTarget.textContent = result.error.message;
          self.cardErrorsTarget.show()
        } else {
          self.stripePaymentMethodIdTarget.value = result.setupIntent.payment_method
          new Request.Rails(self.updateSubscriptionFormTarget).send()
        }
      }
    )
  }
}
